import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import doctor from "../../../assets/doctor tron.png";
import "./WhyChooseTron.scss";

const WhyChooseTron = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isPad, setIsPad] = useState(window.innerWidth < 820);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box className="why-choose-tron">
      <Box className="why-choose-tron__content">
        {/* Text Section */}
        <Box className="why-choose-tron__text">
          <Typography
            variant="h5"
            className="why-choose-tron__title"
            sx={{
              fontSize: isMobile ? "2.3rem" : "2.5rem",
              fontWeight: 700,
            }}
          >
            Why Choose Tron?
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon className="why-choose-tron__icon" />
              </ListItemIcon>
              <ListItemText primary="Zero hidden charges" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon className="why-choose-tron__icon" />
              </ListItemIcon>
              <ListItemText primary="Discounted doctor consultations & treatments" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon className="why-choose-tron__icon" />
              </ListItemIcon>
              <ListItemText primary="Up to 50% off on lab tests + home sample collection" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon className="why-choose-tron__icon" />
              </ListItemIcon>
              <ListItemText primary="1-click OPD appointments & instant e-reports" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon className="why-choose-tron__icon" />
              </ListItemIcon>
              <ListItemText primary="Tailored plans for individuals, families & corporates" />
            </ListItem>
          </List>
        </Box>

        {/* Doctor Image */}
        <Box className="why-choose-tron__image">
          <img
            src={doctor}
            alt="Doctor illustration"
            style={{ display: isMobile ? "none" : "" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default WhyChooseTron;
